import SEOHead from "@/components/General/SEOHead";
import DonateNow from "@/modules/DonateNow/DonateNow";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

const DonateNowPage = () => {
  const { t } = useTranslation("common");
  return (
    <>
      <SEOHead
        title={t("donateNow.title")}
        description={t("donateNow.description")}
      />
      <DonateNow />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale ?? "en", ["common"])),
  },
});

export default DonateNowPage;
